<template>
    <div class="card flex-grow-1">
        <div v-show="panel.header !== ''" class="card-header">
            <p class="h5 mb-0 panel-header">{{ panel.header }}</p>
        </div>
        <div class="card-body panel-card-body d-flex flex-column">
            <div
                class="rich-text-content mb-3"
                v-show="panel.sub_header !== '' && panel.sub_header != '<p></p>'"
                v-html="panel.sub_header"
            ></div>
            <div v-if="isLoaded && !showEmptyMessage">
                <!-- Text Response -->
                <text-response-panel
                    v-if="linked_panel.panel_type == 'textarea'"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.text_responses"
                    :locked="true"
                    :review-mode="true"
                ></text-response-panel>
                <!-- Multichoice & Multiselect -->
                <choice-panel
                    v-else-if="linked_panel.panel_type == 'singleselect' || linked_panel.panel_type == 'multiselect'"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.choice_responses"
                    :locked="true"
                    :review-mode="true"
                ></choice-panel>
                <!-- Order the Steps -->
                <step-order-panel
                    v-else-if="linked_panel.panel_type === 'step_order'"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.choice_responses"
                    :locked="true"
                    :review-mode="true"
                ></step-order-panel>
                <!-- Categories -->
                <categories-panel
                    v-else-if="linked_panel.panel_type === 'categories'"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.choice_responses"
                    :locked="true"
                    :review-mode="true"
                ></categories-panel>
                <!-- Voice Recording -->
                <voice-recording-panel
                    v-else-if="linked_panel.panel_type === 'voice_recording' && !responsesEmpty"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.voice_responses"
                    :locked="true"
                    :review-mode="true"
                ></voice-recording-panel>
                <!-- Custom Form -->
                <custom-form-panel
                    v-else-if="linked_panel.panel_type === 'custom_form'"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.choice_responses"
                    :locked="true"
                    :review-mode="true"
                ></custom-form-panel>
                <!-- Chat Info Panel (psuedo panel) -->
                <chat-info-panel
                    v-else-if="['chat', 'chat_v2'].includes(linked_panel.panel_type)"
                    :panel="linked_panel"
                    :savedResponses="panelResponses.intents_discovered"
                    :review-mode="true"
                ></chat-info-panel>
            </div>
            <div v-else-if="isLoading" class="d-flex justify-content-center py-4">
                <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <!-- Empty Responses Display -->
            <div v-else-if="showEmptyMessage" class="d-flex flex-column justify-content-center">
                <div class="flex-grow-1 py-5">
                    <p class="text-secondary text-center font-weight-500 medium mb-0">
                        {{ labelsTranslated.noResponse }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/axios.js"
import ChoicePanel from "@/components/panels/ChoicePanel"
import TextResponsePanel from "@/components/panels/TextResponsePanel"
import StepOrderPanel from "@/components/panels/StepOrderPanel"
import CategoriesPanel from "@/components/panels/CategoriesPanel"
import VoiceRecordingPanel from "@/components/panels/VoiceRecordingPanel"
import CustomFormPanel from "@/components/panels/CustomFormPanel"
import ChatInfoPanel from "@/components/panels/ChatInfoPanel"

export default {
    name: "LinkedResponsePanel",
    components: {
        ChoicePanel,
        TextResponsePanel,
        StepOrderPanel,
        CategoriesPanel,
        VoiceRecordingPanel,
        CustomFormPanel,
        ChatInfoPanel,
    },
    props: {
        panel: {
            type: Object,
            required: true,
        },
        sessionId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            responses: {},
            linked_panel: {},
            isLoading: false,
            isLoaded: false,
        }
    },
    computed: {
        panelResponses() {
            if (this.panel.linked_response_panel in this.responses) {
                return this.responses[this.panel.linked_response_panel]
            }
            return {
                is_empty: true,
            }
        },
        responsesEmpty() {
            return this.panelResponses.is_empty
        },
        labelsTranslated() {
            return this.$store.getters.sessionLabelsTranslated
        },
        showEmptyMessage() {
            // Only certain panel types should show an empty messages.
            return ["voice_recording", "textarea"].includes(this.linked_panel.panel_type) && this.responsesEmpty
        },
    },
    methods: {
        fetchData() {
            if (!this.panel.linked_response_panel) {
                return
            }
            this.isLoading = true
            let vm = this
            http.get(`/api/students/sessions/${this.sessionId}/panel/${this.panel.linked_response_panel}/responses/`)
                .then(function (response) {
                    vm.responses = response.data.responses
                    vm.linked_panel = response.data.panel
                    vm.isLoaded = true
                })
                .finally(() => (vm.isLoading = false))
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>
